<template>
    <div class="window window-goals window_full">
        <div class="window-header">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.0929 0.929275C11.683 0.929275 7.30406 0.929275 2.90111 0.929275C2.90111 1.0342 2.90111 1.12761 2.90111 1.22167C2.90111 5.66126 2.88782 10.1002 2.90744 14.5398C2.91504 16.2788 2.48145 17.854 1.44844 19.2507C1.43515 19.2686 1.42755 19.2916 1.3978 19.3505C1.49845 19.3505 1.5801 19.3505 1.66175 19.3505C4.34682 19.3505 7.03188 19.3505 9.71695 19.3505C9.79607 19.3505 9.87583 19.3454 9.95368 19.3543C10.1632 19.378 10.3031 19.536 10.2961 19.7414C10.2885 19.9577 10.167 20.0767 9.96381 20.1138C9.90241 20.1247 9.83785 20.1189 9.77455 20.1189C6.74198 20.1189 3.70942 20.1189 0.677483 20.1189C0.645835 20.1189 0.614186 20.1183 0.582538 20.1189C0.399609 20.124 0.258456 20.0562 0.183133 19.8796C0.10591 19.6998 0.171739 19.5533 0.2977 19.4247C0.750908 18.9609 1.12689 18.4401 1.42249 17.8604C1.91747 16.8905 2.14534 15.8578 2.14408 14.7663C2.14028 10.0945 2.14281 5.42262 2.14281 0.751409C2.14281 0.245325 2.23649 0.149994 2.73464 0.149994C7.25153 0.149994 11.769 0.149994 16.2859 0.149994C16.7531 0.149994 16.8512 0.249163 16.8512 0.729016C16.8512 3.17691 16.8512 5.62415 16.8512 8.07204C16.8512 8.47064 16.7366 8.64659 16.4784 8.64915C16.2131 8.65171 16.0935 8.46808 16.0935 8.05669C16.0935 5.79306 16.0935 3.52944 16.0935 1.26581C16.0929 1.16152 16.0929 1.05852 16.0929 0.929275Z" fill="#00614D" stroke="#00614D" stroke-width="0.3"/>
                <path d="M11.2842 13.9896C11.407 13.9512 11.5203 13.8763 11.6115 13.8975C11.7292 13.9243 11.8868 14.0069 11.9223 14.1047C11.966 14.2238 11.9501 14.4272 11.8723 14.5174C11.5938 14.8424 11.2842 15.1425 10.9735 15.4381C10.8133 15.5904 10.6108 15.5699 10.443 15.4055C10.1595 15.1272 9.87968 14.845 9.60561 14.5571C9.4385 14.3824 9.4385 14.1527 9.58978 14.0005C9.74613 13.8431 9.9569 13.8443 10.1373 14.0209C10.2209 14.1028 10.2804 14.2097 10.3715 14.3338C10.5221 13.8853 10.6209 13.5091 10.7715 13.1559C11.6374 11.1265 13.7199 9.95242 15.9265 10.2365C18.0305 10.5071 19.7686 12.2442 20.0927 14.401C20.4047 16.4765 19.3806 18.5507 17.5595 19.5322C15.7075 20.5303 13.4446 20.2315 11.9084 18.7856C11.8735 18.7529 11.8381 18.7209 11.8058 18.6857C11.6368 18.5008 11.6273 18.2903 11.7805 18.1298C11.9324 17.9698 12.1375 17.9768 12.3324 18.1317C12.6236 18.3626 12.9002 18.623 13.2205 18.8041C15.8258 20.2782 18.9976 18.6256 19.354 15.6198C19.604 13.5116 18.1995 11.5219 16.1391 11.065C14.0586 10.6037 11.9432 11.8322 11.3089 13.8693C11.2988 13.9058 11.2937 13.9442 11.2842 13.9896Z" fill="#00614D" stroke="#00614D" stroke-width="0.3"/>
                <path d="M9.51128 7.59027C10.9013 7.59027 12.2913 7.59027 13.6813 7.59027C13.7522 7.59027 13.825 7.58259 13.894 7.59538C14.0984 7.63313 14.22 7.76109 14.2219 7.97287C14.2238 8.17441 14.1073 8.30173 13.9168 8.34651C13.8338 8.36635 13.744 8.35803 13.6572 8.35803C10.8855 8.35867 8.11368 8.35867 5.34127 8.35867C5.31785 8.35867 5.2938 8.35867 5.27038 8.35867C4.95199 8.35611 4.77666 8.21919 4.77666 7.97287C4.77666 7.7259 4.94946 7.59091 5.27038 7.59091C6.6838 7.58963 8.09723 7.59027 9.51128 7.59027Z" fill="#00614D" stroke="#00614D" stroke-width="0.3"/>
                <path d="M9.47775 5.75723C8.08774 5.75723 6.69837 5.75787 5.30837 5.75595C5.21469 5.75595 5.11658 5.75276 5.02859 5.72524C4.84693 5.66766 4.76464 5.52627 4.77984 5.33752C4.79503 5.14814 4.9039 5.02978 5.08999 4.99779C5.16721 4.98435 5.2476 4.98883 5.32609 4.98883C8.10547 4.98819 10.8855 4.98883 13.6649 4.98883C13.6807 4.98883 13.6965 4.98883 13.7123 4.98883C14.0516 4.99139 14.2301 5.12767 14.2231 5.37975C14.2168 5.6216 14.0383 5.75659 13.7174 5.75659C12.3046 5.75787 10.8912 5.75723 9.47775 5.75723Z" fill="#00614D" stroke="#00614D" stroke-width="0.3"/>
                <path d="M7.60542 10.9556C6.80788 10.9556 6.01096 10.9582 5.21342 10.9544C4.91656 10.9531 4.74565 10.7733 4.78173 10.5167C4.81148 10.3043 4.9634 10.1898 5.23178 10.1885C5.97362 10.186 6.7161 10.1879 7.45794 10.1879C8.30232 10.1879 9.14734 10.1866 9.99172 10.1885C10.2443 10.1892 10.3987 10.3024 10.4348 10.4988C10.4816 10.7541 10.3088 10.9524 10.0208 10.9537C9.2157 10.9588 8.41056 10.9556 7.60542 10.9556Z" fill="#00614D" stroke="#00614D" stroke-width="0.3"/>
                <path d="M14.8745 13.6914C14.8745 13.2282 14.8719 12.7644 14.8751 12.3011C14.877 12.0004 15.0251 11.8232 15.2593 11.8302C15.484 11.8366 15.6296 12.01 15.6309 12.2954C15.6347 13.1265 15.6264 13.9576 15.6391 14.7887C15.641 14.9077 15.7011 15.051 15.7821 15.138C16.1391 15.5219 16.5151 15.8866 16.8797 16.2641C17.024 16.4132 17.0455 16.5923 16.9259 16.7657C16.8107 16.9327 16.643 16.9608 16.4638 16.8873C16.4012 16.8617 16.3467 16.8066 16.2967 16.7567C15.8771 16.3345 15.4511 15.918 15.0473 15.4803C14.951 15.376 14.889 15.2027 14.8827 15.0581C14.8612 14.6032 14.8745 14.147 14.8745 13.6914Z" fill="#00614D" stroke="#00614D" stroke-width="0.3"/>
                <path d="M6.68887 13.5577C6.20718 13.5577 5.72612 13.5603 5.24443 13.5571C4.94187 13.5552 4.77413 13.4138 4.77477 13.1738C4.77603 12.9333 4.9444 12.7912 5.24696 12.7906C6.21794 12.788 7.18829 12.7874 8.15927 12.7912C8.50993 12.7925 8.70615 13.0472 8.58525 13.328C8.50803 13.5072 8.35865 13.5577 8.18015 13.5577C7.68327 13.5571 7.18639 13.5577 6.68887 13.5577Z" fill="#00614D" stroke="#00614D" stroke-width="0.3"/>
            </svg>

            <div class="window-header__title">
                План продаж
            </div>

            <CustomSelect
                v-if="chartOptions"
                class="white minimized"
                v-model="chartSelectedOption"
                :options="chartOptions"
                :with_search="false"
            />

            <div class="window-header-indicators">
                <span>
                    <div class="circle blue"></div>
                    план
                </span>
                <span>
                    <div class="circle red"></div>
                    выручка
                </span>
                <span>
                    <div class="circle yellow"></div>
                    LFL
                </span>
            </div>
        </div>
        <div class="window-body">
            <div class="window-body-chart">
                <Line
                    v-if="chartData && chartSelectedOption"
                    id="chart-unit_cost"
                    :options="chartSettings"
                    :data="chartData[chartSelectedOption]"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { Line } from 'vue-chartjs'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js'
ChartJS.register( CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

import { mapActions } from 'vuex'
import CustomSelect from '@/components/CustomSelect.vue';

export default {
    data() {
        return {
            chartSettings: {
                responsive: true,
                plugins: {
                    legend: {
                        display: false
                    },
                }
            },

            chartOptions: null,
            chartSelectedOption: null,
            chartData: null
        }
    },

    components: {
        Line,
        CustomSelect
    },

    methods: {
        ...mapActions({
            getDashboardChart: 'home/getDashboardChart'
        }),

        fetchChart() {
            this.getDashboardChart()
            .then((result) => {
                if(result) {
                    this.initChart(result)

                    const options = []
                    for(let item in result) {
                        const option = {
                            label: item,
                            value: item
                        }

                        options.push(option)
                    }
                    this.chartSelectedOption = options[0].value
                    this.chartOptions = options
                }
            })
        },

        initChart(data) {
            const chartData = {}

            const ruDateFormatter = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long' });

            const makeDataset = (label, bg, border, extra = {}) => ({
                label,
                backgroundColor: bg,
                borderColor: border,
                data: [],
                tension: 0.3,
                ...extra
            });

            for (const key in data) {
                // создаём пустую структуру для каждой группы
                chartData[key] = {
                    labels: [],
                    datasets: []
                }

                // берём и сортируем даты по возрастанию
                const dates = Object.keys(data[key] || {}).sort((a, b) => new Date(a) - new Date(b));

                // создаём отдельные объекты наборов данных для этой группы
                const plan = makeDataset('План', '#DB4B29', '#DB4B29');
                const fact = makeDataset('Выручка', '#FF6161', '#FF6161', { spanGaps: true });
                const lfl = makeDataset('LFL', '#00614D', '#00614D', { spanGaps: true });

                for (const label of dates) {
                    const day = data[key][label] || { plan: 0, fact: 0, lfl: 0 };
                    chartData[key].labels.push(ruDateFormatter.format(new Date(label)));
                    plan.data.push(day.plan ?? 0);
                    fact.data.push(day.fact ?? 0);
                    lfl.data.push(day.lfl ?? 0);
                }

                chartData[key].datasets.push(plan, fact, lfl)
            }

            this.chartData = chartData
            console.log(chartData);
        }
    },

    mounted() {
        this.fetchChart()
    }
}
</script>

<style scoped lang="sass">
.window
    &-header
        &-indicators
            margin-left: auto
            display: flex
            align-items: center
            gap: 10px
            & span
                display: flex
                align-items: center
                gap: 5px
                line-height: 100%
                & .circle 
                    width: 10px
                    height: 10px
                    border-radius: 50%
                    &.blue
                        background: var(--color-blue)
                    &.red
                        background: var(--color-red)
                    &.yellow
                        background: var(--color-yellow)
    &-body
        &-chart
            padding: 18px
            @media only screen and  (max-width: 425px)
                padding: 8px

</style>